import React, { useEffect, useState, useRef } from "react";
import calender from "../../Assets/Images/calender.png";
import Widgets from "../index";
import { t } from "../../Utils/translate";

function AppointmentComponent({
  appointment,
  selectedAppointmentIndex,
  setSelectedAppointmentIndex,
  handleCardClick,
  specificDate,
  selectedSlot,
  selectedDoctor,
  requestApp,
  selectedreqCardType,
  refreshAppointments,
  zoomClass2,
  appointmentId
}) {
  const [appointments, setAppointments] = useState([]);

  const cardRefs = useRef({});

  useEffect(() => {
    setAppointments(appointment);
  }, [appointment]);

  useEffect(() => {
    if (appointments.length > 0 && selectedAppointmentIndex && cardRefs.current[selectedAppointmentIndex]) {
      cardRefs.current[selectedAppointmentIndex].scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [appointments, selectedAppointmentIndex]);

  const renderAppointments = () => {
    return appointments.map((appt) => (
      <div key={appt._id} ref={(el) => (cardRefs.current[appt._id] = el)}>
        <Widgets.AppointmentCard3
          appointment={appt}
          isSelected={selectedAppointmentIndex === appt._id }
          onClick={() => handleCardClick(appt._id)}
          setSelectedAppointmentIndex={setSelectedAppointmentIndex}
          requestApp={requestApp}
          selectedAppointmentIndex={selectedAppointmentIndex}
          refreshAppointments={refreshAppointments}
          appointmentId={appointmentId}
        />
      </div>
    ));
  };

  return (
    <div className={`overflow-y-auto app-left-cards`}>
      {appointments.length > 0 ? (
        renderAppointments()
      ) : (
        <div className="appointment-msg">
          <img className="no-appointments-image no-appointment-resp ml-[40%]" src={calender} alt="calendar" />
          <br />
          <span className="no-appointment-span">{t("NoAppointmentsAvailable")}</span>
        </div>
      )}
    </div>
  );
}

export default AppointmentComponent;
